import React from 'react';
import { Navigate } from 'react-router-dom';

const ChatHome = React.lazy(() => import('../pages/ChatAppViews/ChatHome.js'));
const ChatThread = React.lazy(() => import('../pages/ChatAppViews/ChatThread.js'));

const ChatAppRoutes = [
    { path: '', element: <ChatHome /> }, // maps to "/"
    { path: 'thread/:sessionId', element: <ChatThread /> }, // maps to "/thread"
    // { path: '*', element: <Navigate to="/" replace /> } // redirect fallback
];

export default ChatAppRoutes;
